import { render, staticRenderFns } from "./ToggleStatus.vue?vue&type=template&id=5bb82ea0&scoped=true&"
import script from "./ToggleStatus.vue?vue&type=script&lang=js&"
export * from "./ToggleStatus.vue?vue&type=script&lang=js&"
import style0 from "./ToggleStatus.vue?vue&type=style&index=0&id=5bb82ea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb82ea0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
